<script>
const defaultIcon = `
  <svg
    width="11"
    height="10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5.5" cy="5" r="5" fill="#9A67FF" />
  </svg>`;

function generateId() {
  return Math.random().toString(36).substr(2, 9);
}

function resolveIcon() {
  const id = generateId();

  return `
    <svg
      width="11"
      height="10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5.5" cy="5" r="5" fill="url(#${id}" />
      <defs>
        <linearGradient
          id="${id}"
          x1="1.5"
          y1=".5"
          x2="18"
          y2="14.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".042" stop-color="#F33" />
          <stop offset=".387" stop-color="#48F2F2" />
          <stop offset=".656" stop-color="#FCFF85" />
        </linearGradient>
      </defs>
    </svg>
  `;
}

function generateFcpIcon() {
  const id = generateId();

  return `
    <svg
      width="11"
      height="10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5.5" cy="5" r="5" fill="url(#${id}" />
      <defs>
        <linearGradient
          id="${id}"
          x1="1.75"
          y1="1"
          x2="9"
          y2="9.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#91FF53" />
          <stop offset="1" stop-color="#FF4F43" />
        </linearGradient>
      </defs>
    </svg>
  `;
}

function generateCategories() {
  return {
    presets: [
      {
        icon: defaultIcon,
        text: 'Adobe After Effects',
        link: '/browse/after-effects-presets/',
      },
      {
        icon: defaultIcon,
        text: 'Adobe Premiere Pro',
        link: '/browse/premiere-pro-presets/',
      },
      {
        icon: resolveIcon(),
        text: 'DaVinci Resolve Macros',
        link: '/browse/davinci-resolve-macros/',
      },
    ],

    templates: [
      {
        icon: defaultIcon,
        text: 'Adobe After Effects',
        link: '/browse/after-effects-templates/',
      },
      {
        icon: defaultIcon,
        text: 'Adobe Premiere Pro',
        link: '/browse/premiere-pro-templates/',
      },
      {
        icon: defaultIcon,
        text: 'Motion Graphics',
        link: '/browse/motion-graphics-templates/',
      },
      {
        icon: defaultIcon,
        text: 'Adobe Premiere Rush',
        link: '/browse/premiere-rush-templates/',
      },
      {
        icon: resolveIcon(),
        text: 'Davinci Resolve',
        link: '/browse/davinci-resolve-macros/',
      },
      {
        icon: generateFcpIcon(),
        text: 'Final Cut Pro',
        link: '/browse/final-cut-pro-templates/',
      },
    ],

    audio: [
      {
        icon: `
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" fill="none">
          <rect width="23" height="23" y=".5" fill="#2D2E4A" rx="11.5"/><path fill="#FFFDFA" d="M11.5 14.25A2.221 2.221 0 0 1 9.25 12V8.25c0-1.242.984-2.25 2.25-2.25a2.25 2.25 0 0 1 2.25 2.25V12a2.236 2.236 0 0 1-2.25 2.25Zm3.563-3.75a.57.57 0 0 1 .562.563V12c0 2.086-1.57 3.82-3.563 4.102v.773H13c.422 0 .75.375.727.797 0 .187-.165.328-.352.328h-3.75c-.21 0-.375-.14-.375-.328a.751.751 0 0 1 .75-.797h.938v-.797c-2.086-.281-3.563-2.156-3.563-4.242v-.774c0-.304.234-.562.563-.562a.57.57 0 0 1 .562.563v.82c0 1.57 1.242 3.023 2.79 3.117a3 3 0 0 0 3.21-3v-.938c0-.304.234-.562.563-.562Z"/></svg>
        `,
        text: 'Royalty Free Music',
        link: '/browse/royalty-free-music/',
      },
      {
        icon: `
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" fill="none"><rect width="23" height="23" y=".5" fill="#2D2E4A" rx="11.5"/><path fill="#FFFDFA" d="M16 13.781c0 .967-.924 1.719-2.063 1.719-1.16 0-2.062-.752-2.062-1.719 0-.945.902-1.719 2.063-1.719.236 0 .45.043.687.108V9.076l-5.5 1.611v4.47c0 .966-.924 1.718-2.063 1.718-1.16 0-2.062-.752-2.062-1.719 0-.945.902-1.719 2.063-1.719.236 0 .45.043.687.108V8.604c0-.28.215-.58.473-.666l6.875-2.02a.635.635 0 0 1 .214-.043c.366 0 .667.322.688.688v7.218Z"/></svg>
        `,
        text: 'Sound Effects',
        link: '/browse/sound-effects/',
      },
    ],

    video: [
      {
        icon: `
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" fill="none"><rect width="23" height="23" y=".5" fill="#2D2E4A" rx="11.5"/><path fill="#FFFDFA" d="M13.563 9.281v6.188c0 .58-.473 1.031-1.032 1.031H6.344c-.58 0-1.032-.451-1.032-1.031V9.28c0-.558.452-1.031 1.032-1.031h6.187c.559 0 1.031.473 1.031 1.031Zm4.124.344v5.521c0 .538-.644.86-1.095.56l-2.342-1.634V10.7l2.342-1.633c.451-.3 1.096.022 1.096.559Z"/></svg>
        `,
        text: 'Footage',
        link: '/browse/stock-video/',
      },
      {
        icon: `
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" fill="none"><rect width="23" height="23" y=".5" fill="#2D2E4A" rx="11.5"/><path fill="#FFFDFA" d="M12.688 12.375c0 .215-.086.43-.258.602L8.648 16.93a.83.83 0 0 1-1.203.021.83.83 0 0 1-.021-1.203l3.201-3.373-3.201-3.352a.83.83 0 0 1 .021-1.203.83.83 0 0 1 1.203.022l3.782 3.953a.839.839 0 0 1 .258.58Zm3.867-.58a.839.839 0 0 1 .258.58c0 .215-.086.43-.258.602l-3.782 3.953a.83.83 0 0 1-1.203.021.83.83 0 0 1-.021-1.203l3.201-3.373-3.201-3.352a.83.83 0 0 1 .021-1.203.83.83 0 0 1 1.203.022l3.782 3.953Z"/></svg>
        `,
        text: 'Motion Graphics',
        link: '/browse/stock-motion-graphics/',
      },
    ],
    images: [
      {
        icon: `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><rect width="23" height="23" x=".5" y=".5" fill="#2D2E4A" rx="11.5"/><path fill="#FFFDFA" d="m9.156 9.465 2.95-.82 2.5 2.5-.82 2.949a1.26 1.26 0 0 1-.821.84L7.496 16.75l-.273-.273 2.93-2.93a.889.889 0 0 0 .39.098c.527 0 .938-.43.938-.938a.926.926 0 0 0-.938-.938.938.938 0 0 0-.938.938c0 .137.04.273.098.39l-2.93 2.93-.273-.273 1.816-5.469c.118-.39.45-.703.84-.82Zm7.051-1.25c.371.351.371.957 0 1.328l-1.094 1.094-2.5-2.5 1.094-1.094c.371-.371.977-.371 1.328 0l1.172 1.172Z"/></svg>
        `,
        text: 'Graphics',
        link: '/browse/graphics/',
      },
      {
        icon: `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><rect width="23" height="23" x=".5" y=".5" fill="#2D2E4A" rx="11.5"/><path fill="#FFFDFA" d="M15.25 7.375c.684 0 1.25.566 1.25 1.25v6.25c0 .703-.566 1.25-1.25 1.25h-7.5c-.703 0-1.25-.547-1.25-1.25v-6.25c0-.684.547-1.25 1.25-1.25h7.5Zm-6.563 1.25a.938.938 0 0 0-.937.938c0 .527.41.937.938.937.507 0 .937-.41.937-.938a.95.95 0 0 0-.938-.937Zm6.524 6.094a.354.354 0 0 0-.02-.313l-2.5-3.75a.305.305 0 0 0-.254-.156.312.312 0 0 0-.273.156l-1.816 2.735-.645-.88c-.058-.077-.137-.136-.234-.136a.305.305 0 0 0-.254.137l-1.367 1.875c-.078.097-.078.215-.04.332a.321.321 0 0 0 .294.156h6.835a.337.337 0 0 0 .274-.156Z"/></svg>
        `,
        text: 'Photos',
        link: '/browse/stock-photos/',
      },
    ],

    tools: [
      {
        icon: `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><rect width="23" height="23" x=".5" y=".5" fill="#2D2E4A" rx="11.5"/><path fill="#FFFDFA" d="M14 7.375V9.25h-1.25V7.375a.63.63 0 0 1 .625-.625c.332 0 .625.293.625.625Zm.938 2.5c.156 0 .312.156.312.313v.624a.321.321 0 0 1-.313.313h-.312v.625a3.137 3.137 0 0 1-2.5 3.066v1.934h-1.25v-1.934a3.117 3.117 0 0 1-2.5-3.066v-.625h-.313a.308.308 0 0 1-.312-.313v-.624c0-.157.137-.313.313-.313h6.874Zm-4.688-2.5V9.25H9V7.375a.63.63 0 0 1 .625-.625c.332 0 .625.293.625.625Z"/></svg>
        `,
        text: 'Integrations',
        link: '/integrations/adobe/',
      },
    ],

    photos: '/browse/stock-photos/',
    plugins: '/plugins/',
    learn: '/learn/',
  };
}

function cleanPathStr(str = '') {
  return str.replace(/\/$/, '');
}

export function getActiveCategory(currentPath) {
  const cleanPath = cleanPathStr(currentPath);
  const categories = generateCategories();

  for (const category in categories) {
    if (Array.isArray(categories[category])) {
      const isActive = categories[category].some(link => cleanPathStr(link.link) === cleanPath);

      if (isActive) {
        return category;
      }
    } else if (cleanPathStr(categories[category]) === cleanPath) {
      return category;
    }
  }

  return null;
}

export default {
  functional: true,

  props: {
    category: {
      type: String,
      default: () => null,
    },

    tag: {
      type: String,
      default: () => 'div',
    },
  },

  render(h, ctx) {
    const categories = generateCategories();
    const links = Array.isArray(categories[ctx.props.category])
      ? categories[ctx.props.category]
      : [];

    const children = links.map(link => {
      return ctx.data.scopedSlots.link({
        ...link,
        icon: {
          template: link.icon,
        },
        isSelected: currentPath => cleanPathStr(link.link) === cleanPathStr(currentPath),
      });
    });

    if (ctx.scopedSlots.close) {
      children.push(...ctx.scopedSlots.close());
    }
    return h(ctx.props.tag, ctx.data, children);
  },
};
</script>
